import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getSizeChartList = createAsyncThunk(
  "get-size-chart",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("size-chart/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

/**
 * Every chart, unpaginated - the picker needs to know which sizes other charts
 * already hold. Deliberately has no reducer so it does not disturb the table's
 * paginated list.
 */
export const getAllSizeCharts = createAsyncThunk(
  "get-all-size-charts",
  async (_, { dispatch }) => {
    try {
      const response = await axios.get("size-chart/list");
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createSizeChart = createAsyncThunk(
  "create-size-chart",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("size-chart", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateSizeChart = createAsyncThunk(
  "update-size-chart",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`size-chart/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteSizeChart = createAsyncThunk(
  "delete-size-chart",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`size-chart/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const sizeChartSlice = createSlice({
  name: "sizeChart",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSizeChartList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSizeChartList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.sizeChartList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getSizeChartList.rejected, (state) => {
        state.loading = false;
        state.list = [];
        state.perPage = "";
        state.total = 0;
      });
  },
});

export default sizeChartSlice.reducer;
